/**
 * Canonical authorization rules shared by the web app and the assistant MCP.
 *
 * The web app imports these at runtime (Vite bundles @otm/shared source).
 * Cloud Functions cannot runtime-import @otm/shared (it is emit-declaration-only),
 * so the MCP inlines a copy of `canUseAssistant` with a pointer back to this file
 * — same convention as functions/src/assistant/tools/searchEvents.ts. Keep them
 * in sync; this file is the source of truth for the rule.
 */

/** The Single Authorization that grants read-only assistant access. */
export const ASSISTANT_AUTHORIZATION = 'Assistant (read-only)';

/** Minimal contact shape the assistant gate depends on. */
export interface AssistantAccessContact {
  accountLevel?: string | null;
  authorizations?: string[] | null;
}

/**
 * Who may use the OTM assistant (in-app chat AND the MCP server):
 * Admins / Super-Admins, or anyone explicitly granted `ASSISTANT_AUTHORIZATION`.
 */
export function canUseAssistant(contact: AssistantAccessContact): boolean {
  const level = contact?.accountLevel;
  return (
    level === 'Admin' ||
    level === 'Super Admin' ||
    (contact?.authorizations ?? []).includes(ASSISTANT_AUTHORIZATION)
  );
}
